import { observer } from "mobx-react-lite";

import * as Node from "@/components/expression/utils/layout";
import { useMathSpeech } from "@/components/expression/utils/useMathSpeech";

import type { NodeModel } from "@/models/nodes/types";
import type { ComponentProps } from "react";

type Props = {
  /** Math the input is labelled with, as spoken text. */
  mathNode?: NodeModel;
} & ComponentProps<typeof Node.Input>;

/**
 * A node input labelled with speech for `mathNode`.
 *
 * Speech arrives asynchronously, so it lives here to re-render only the input, not the editor
 * logic around it.
 */
export const InputWithMath = observer(function InputWithMath({ mathNode, ...props }: Props) {
  const speech = useMathSpeech(mathNode);

  return <Node.Input aria-label={speech} {...props} />;
});
